(function () {
  'use strict';

  // --- Inject CSS ---
  var styleEl = document.createElement('style');
  styleEl.textContent =
    '.ff-fabric-info{font-family:\'Poppins\',sans-serif;background:#fcf9f0;border:1px solid #e8e3dc;border-radius:6px;padding:12px 14px;margin-top:10px;}' +
    '.ff-fabric-info.ff-fi-in{animation:ff-fi-slide .2s ease both;}' +
    '@keyframes ff-fi-slide{from{opacity:0;transform:translateY(-5px)}to{opacity:1;transform:translateY(0)}}' +
    '.ff-fi-badges{display:flex;gap:6px;flex-wrap:wrap;margin-bottom:10px;}' +
    '.ff-fi-badge{display:inline-block;padding:3px 10px;border-radius:4px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.06em;background:#161e25;color:#f5b700;}' +
    '.ff-fi-badge--stretch{background:#253952;color:#fcf9f0;}' +
    '.ff-fi-composition{font-size:12px;font-weight:600;color:#253952;margin:0 0 3px;}' +
    '.ff-fi-feel{font-size:12px;color:#6a5e53;margin:0 0 10px;}' +
    '.ff-fi-bestfor{font-size:12px;color:#161e25;margin:0;padding-top:9px;border-top:1px solid #e8e3dc;}' +
    '.ff-fi-bestfor-label{font-weight:700;color:#f98e69;margin-right:3px;}';
  document.head.appendChild(styleEl);

  // --- Fabric specs (source: family-fabrics.com/pages/fabric-spec-page) ---
  var FABRIC_DATA = {
    'premium jersey 180': {
      weight: '180 GSM', width: '150 cm', stretch: 'Gentle stretch',
      composition: '95% Cotton · 5% Elastane',
      feel: 'Soft & smooth, lightweight and breathable',
      bestFor: 'Casual wear, loungewear, babywear, T-shirts'
    },
    'premium jersey 220': {
      weight: '220 GSM', width: '150 cm', stretch: 'Gentle stretch',
      composition: '95% Cotton · 5% Elastane',
      feel: 'Smooth with enhanced colour saturation',
      bestFor: 'Casual wear, everyday garments, vibrant designs'
    },
    'soft jersey': {
      weight: '220 GSM', width: '150 cm', stretch: 'Gentle stretch',
      composition: '95% Cotton · 5% Elastane',
      feel: 'Soft & smooth, refined subtle texture',
      bestFor: 'Minimalist designs, casual wear, loungewear'
    },
    'premium french terry': {
      weight: '230 GSM', width: '150 cm', stretch: 'Comfortable stretch',
      composition: '95% Cotton · 5% Elastane',
      feel: 'Soft looped-back knit, cosy yet breathable',
      bestFor: 'Sweatshirts, hoodies, loungewear, activewear'
    },
    'french terry': {
      weight: '230 GSM', width: '150 cm', stretch: 'Comfortable stretch',
      composition: '95% Cotton · 5% Elastane',
      feel: 'Soft looped-back knit, cosy yet breathable',
      bestFor: 'Sweatshirts, hoodies, loungewear, activewear'
    },
    'babyrib': {
      weight: '260 GSM', width: '110 cm', stretch: 'Gentle stretch',
      composition: '95% Cotton · 5% Elastane',
      feel: 'Soft, fine-ribbed with smooth texture',
      bestFor: 'Babywear, casual clothing, snug accessories'
    },
    'baby rib': {
      weight: '260 GSM', width: '110 cm', stretch: 'Gentle stretch',
      composition: '95% Cotton · 5% Elastane',
      feel: 'Soft, fine-ribbed with smooth texture',
      bestFor: 'Babywear, casual clothing, snug accessories'
    },
    'irregular rib': {
      weight: '210 GSM', width: '140 cm', stretch: 'Gentle stretch',
      composition: '95% Cotton · 5% Elastane',
      feel: 'Textured with uneven raised ribs',
      bestFor: 'Garments, home décor, accessories'
    },
    'irragular rib': {
      weight: '210 GSM', width: '140 cm', stretch: 'Gentle stretch',
      composition: '95% Cotton · 5% Elastane',
      feel: 'Textured with uneven raised ribs',
      bestFor: 'Garments, home décor, accessories'
    },
    'pointelle': {
      weight: '190 GSM', width: '150 cm', stretch: 'Gentle stretch',
      composition: '100% Cotton',
      feel: 'Open-knit with decorative patterned holes',
      bestFor: 'Airy garments, loungewear, layered pieces'
    },
    'waffle': {
      weight: '200 GSM', width: '140 cm', stretch: 'Slight stretch',
      composition: '95% Cotton · 5% Elastane',
      feel: 'Lightweight waffle-weave texture',
      bestFor: 'Towels, baby blankets, bathrobes, loungewear'
    },
    'terrycloth': {
      weight: '235 GSM', width: '160 cm', stretch: 'Minimal stretch',
      composition: '80% Cotton · 20% Polyester',
      feel: 'Soft, absorbent looped pile',
      bestFor: 'Towels, bathrobes, baby items'
    },
    'poplin': {
      weight: '130 GSM', width: '150 cm', stretch: 'No stretch',
      composition: '100% Cotton',
      feel: 'Crisp, fine tightly-woven texture',
      bestFor: 'Shirts, dresses, casual tailoring'
    },
    'cotton satin': {
      weight: '130 GSM', width: '150 cm', stretch: 'No stretch',
      composition: '100% Cotton',
      feel: 'Smooth, silky surface with subtle sheen',
      bestFor: 'Garments, bedding, home décor'
    },
    'linen cotton': {
      weight: '200 GSM', width: '135 cm', stretch: 'No stretch',
      composition: '55% Linen · 45% Cotton',
      feel: 'Breathable, lightly textured, elegant',
      bestFor: 'Apparel, table linens, light home décor'
    },
    'muslin': {
      weight: '130 GSM', width: '140 cm', stretch: 'No stretch',
      composition: '100% Cotton',
      feel: 'Lightweight, plain-weave, soft',
      bestFor: 'Baby muslins, dressmaking, craft projects'
    },
    'canvas': {
      weight: '350 GSM', width: '150 cm', stretch: 'No stretch',
      composition: '100% Cotton',
      feel: 'Sturdy, tight balanced weave',
      bestFor: 'Cushions, tote bags, light upholstery'
    },
    'swim': {
      weight: '240 GSM', width: '150 cm', stretch: 'Four-way stretch',
      composition: '90% Polyester · 10% Elastane',
      feel: 'Snug and supportive, quick-drying',
      bestFor: 'Swimwear, leggings, sports bras'
    },
    'activewear': {
      weight: '240 GSM', width: '150 cm', stretch: 'Four-way stretch',
      composition: '90% Polyester · 10% Elastane',
      feel: 'Snug and supportive, quick-drying',
      bestFor: 'Leggings, sports bras, activewear'
    },
    'beach towel': {
      weight: '400 GSM', width: '50×100 cm or 100×180 cm', stretch: 'No stretch',
      composition: '50% Cotton · 50% Polyester',
      feel: 'Thick, soft & wonderfully plush — premium beach feel',
      bestFor: 'Beach, pool, bathroom — anywhere you want luxury'
    },
    'sport towel': {
      weight: '200 GSM', width: '50×100 cm or 100×180 cm', stretch: 'No stretch',
      composition: '100% Microfibre',
      feel: 'Lightweight, ultra-compact and quick-drying',
      bestFor: 'Gym, travel, outdoor sports — fits in any bag'
    },
    '400 gsm': {
      weight: '400 GSM', width: '50×100 cm or 100×180 cm', stretch: 'No stretch',
      composition: '50% Cotton · 50% Polyester',
      feel: 'Thick, soft & wonderfully plush — premium beach feel',
      bestFor: 'Beach, pool, bathroom — anywhere you want luxury'
    },
    '200 gsm': {
      weight: '200 GSM', width: '50×100 cm or 100×180 cm', stretch: 'No stretch',
      composition: '100% Microfibre',
      feel: 'Lightweight, ultra-compact and quick-drying',
      bestFor: 'Gym, travel, outdoor sports — fits in any bag'
    },
    'sherpa blanket': {
      weight: '400 GSM', width: '120×150 cm or 150×200 cm', stretch: 'No stretch',
      composition: '100% Polyester (printed side) · Sherpa fleece reverse',
      feel: 'Incredibly soft, warm and plush — cloud-like Sherpa on the reverse',
      bestFor: 'Sofa, bedroom, gifting — cosy for the whole family'
    },
    'sherpa': {
      weight: '400 GSM', width: '120×150 cm or 150×200 cm', stretch: 'No stretch',
      composition: '100% Polyester (printed side) · Sherpa fleece reverse',
      feel: 'Incredibly soft, warm and plush — cloud-like Sherpa on the reverse',
      bestFor: 'Sofa, bedroom, gifting — cosy for the whole family'
    },
    'blanket': {
      weight: '400 GSM', width: '120×150 cm or 150×200 cm', stretch: 'No stretch',
      composition: '100% Polyester (printed side) · Sherpa fleece reverse',
      feel: 'Incredibly soft, warm and plush — cloud-like Sherpa on the reverse',
      bestFor: 'Sofa, bedroom, gifting — cosy for the whole family'
    }
  };

  function normalize(str) {
    return (str || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function findSpecs(text) {
    var t = normalize(text);
    if (FABRIC_DATA[t]) return FABRIC_DATA[t];
    var keys = Object.keys(FABRIC_DATA);
    for (var i = 0; i < keys.length; i++) {
      if (t.indexOf(keys[i]) !== -1) return FABRIC_DATA[keys[i]];
    }
    return null;
  }

  function renderPanel(panel, specs) {
    panel.innerHTML =
      '<div class="ff-fi-badges">' +
        '<span class="ff-fi-badge">' + specs.weight + '</span>' +
        '<span class="ff-fi-badge">' + specs.width + '</span>' +
        '<span class="ff-fi-badge ff-fi-badge--stretch">' + specs.stretch + '</span>' +
      '</div>' +
      '<p class="ff-fi-composition">' + specs.composition + '</p>' +
      '<p class="ff-fi-feel">' + specs.feel + '</p>' +
      '<p class="ff-fi-bestfor"><span class="ff-fi-bestfor-label">Best for</span> ' + specs.bestFor + '</p>';
    panel.hidden = false;
    panel.classList.remove('ff-fi-in');
    void panel.offsetWidth;
    panel.classList.add('ff-fi-in');
  }

  function setupPicker(picker) {
    var wrapper = picker.closest('.hdt-product__variant-picker') || picker.parentElement;
    // If a panel already exists in this wrapper, reuse it — never create a second one
    var panel = wrapper.querySelector('.ff-fabric-info');
    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'ff-fabric-info';
      panel.hidden = true;
      wrapper.appendChild(panel);
    }

    // The Kalles theme keeps <span update-value> in sync with the current selection
    function getSelectedText() {
      var span = picker.querySelector('[update-value]');
      if (span && span.textContent.trim()) return span.textContent.trim();
      // Fallback: read button text
      var btn = picker.querySelector('button.hdt-select');
      if (btn && btn.textContent.trim()) return btn.textContent.trim();
      return '';
    }

    function updatePanel() {
      var text = getSelectedText();
      var specs = findSpecs(text);
      if (specs) renderPanel(panel, specs);
      else panel.hidden = true;
    }

    // Initial render
    updatePanel();

    // Watch [update-value] span — Kalles updates this on every selection change
    var updateSpan = picker.querySelector('[update-value]');
    if (updateSpan) {
      new MutationObserver(updatePanel).observe(updateSpan, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    // Also watch selected-variant attribute as a backup
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'selected-variant') updatePanel();
      });
    }).observe(picker, { attributes: true });
  }

  function init() {
    document.querySelectorAll('hdt-variant-picker[handle]').forEach(function (picker) {
      // Skip the duplicate picker inside the sticky ATC bar
      if (picker.closest('hdt-sticky-btn-atc') || picker.closest('.hdt-sticky-btn-atc')) return;
      // Skip if already initialised
      if (picker.dataset.ffFabricInit) return;
      picker.dataset.ffFabricInit = '1';
      setupPicker(picker);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
